import liff from '@line/liff'
import { Modal } from 'antd-mobile'

import { getLanguage } from './language'

export function checkImeiJp() {
  if (
    getLanguage() === 'ja_JP' &&
    window.location.hostname !== 'imei-jp.charge-spot.com' &&
    !localStorage.getItem('CHARGESPOT::imeiJpModal')
  ) {
    Modal.alert(
      '日本 IMEI 新サイト',
      `https://imei-jp.charge-spot.com に遷移います、今は ${window.location.hostname} を使っています`,
      [
        {
          text: '新サイトへ遷移する',
          onPress: (e) => {
            window.location.href = 'https://imei-jp.charge-spot.com'
          },
        },
        { text: '閉じる' },
        {
          text: '次回は表示しない',
          onPress: () => {
            localStorage.setItem(
              'CHARGESPOT::imeiJpModal',
              JSON.stringify({ data: 'shown' })
            )
          },
        },
      ]
    )
  }
}

export function checkLineApp() {
  if (
    window.location.hostname === 'imei-jp.charge-spot.com' &&
    /Line/.test(window.navigator.userAgent) &&
    !liff.isInClient() &&
    !localStorage.getItem('CHARGESPOT::imeiJpLineModal')
  ) {
    Modal.alert(
      'LINEミニアプリがあります',
      `https://liff.line.me/1657369573-brkOjzZD\nミニアプリでより使いやういコードリーダーがあります`,
      [
        {
          text: 'LINEミニアプリへ遷移する',
          onPress: (e) => {
            window.location.href = 'https://liff.line.me/1657369573-brkOjzZD'
          },
        },
        { text: '閉じる' },
        {
          text: '次回は表示しない',
          onPress: () => {
            localStorage.setItem(
              'CHARGESPOT::imeiJpLineModal',
              JSON.stringify({ data: 'shown' })
            )
          },
        },
      ]
    )
  }

  if (
    window.location.hostname === 'imei-tw.charge-spot.com' &&
    /Line/.test(window.navigator.userAgent) &&
    !liff.isInClient() &&
    !localStorage.getItem('CHARGESPOT::imeiTwLineModal')
  ) {
    Modal.alert(
      'LINE MiniAPP',
      `https://liff.line.me/2007943417-RaGkKpAB\n有一個更易於使用的應用程式,LINE MiniAPP`,
      [
        {
          text: '轉移到LINE MiniAPP',
          onPress: (e) => {
            window.location.href = 'https://liff.line.me/2007943417-RaGkKpAB'
          },
        },
        { text: '關閉' },
        {
          text: '下次不再顯示',
          onPress: () => {
            localStorage.setItem(
              'CHARGESPOT::imeiTwLineModal',
              JSON.stringify({ data: 'shown' })
            )
          },
        },
      ]
    )
  }
}
